export enum AuthActions {
    AUTHENTICATE_TOKEN = 'AUTHENTICATE_TOKEN',
    AUTHENTICATED_USER = 'AUTHENTICATED_USER',
    LOGOUT = 'LOGOUT',
    EXPIRED_TOKEN = 'EXPIRED_TOKEN',
}